import React, {Component, useState} from 'react';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';

import {
    Accordion,
    AccordionItem,
    AccordionSkeleton, Button,
    ComboBox,
    Dropdown
} from "carbon-components-react";
import {Undo16} from "@carbon/icons-react";

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default class extends Component {

    state = {
        isOppenedSubmit: false,
        skuDetailsisOpenend: false,
        form: {
            filial: "",
        }
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

    }


    async handleChange(e) {
        //const name = event.target.name;
        //console.log(name);
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [name]: value
            }
        }));
        //console.log(this.state);
    }

    handleSubmit = (e) => {
        window.location.href = '/ij/rh_edit/' + this.state.form.filial;
    }

    handleSetClear = (e) => {
        e.preventDefault();
        this.setState({
            form: {
                form: "",
                cost_center: "",
            }
        });

    }


    render() {
        let {data_filial, isLoading} = this.props;
        return (
            <div style={{minHeight: "80vh"}}>
                <form>
                    <div className="bx--row bx--fieldset">
                        <div className="bx--col-md-6 bx--col-lg-7 content-pt-1"><p>To generate a Review you need to
                            select Filters options.</p></div>
                        <div className="bx--col-md-2 bx--col-lg-3 content-align-center">
                            <Button onClick={e => {
                                this.handleSubmit(e)
                            }} kind='primary'
                                    disabled={(this.state.form.filial !== "") ? false : true}>Generate
                                Review</Button>
                            <span className="content-ml-10">
                            <Button
                                hasIconOnly
                                renderIcon={Undo16}
                                tooltipAlignment="center"
                                tooltipPosition="bottom"
                                iconDescription="Reset"
                                kind='secondary'
                                onClick={e => {
                                    this.handleSetClear(e)
                                }}
                            />
                            </span>
                        </div>
                    </div>
                    {isLoading ? (
                        <AccordionSkeleton/>
                    ) : (
                        <Accordion className="bx--accordion-80">
                            <AccordionItem open={true} title="1. Filters">
                                <div className="clearfix">
                                    <div className="row bx--col-padding bx--row-padding" style={{paddingLeft: "20px"}}>
                                        <div className="col-md-6 bx--col-padding bx--row-padding">


                                            <Autocomplete
                                                id="combo-box-demo"
                                                options={data_filial}
                                                getOptionLabel={(option) => option.label}
                                                style={{width: "100%"}}
                                                renderInput={(params) => <TextField {...params} label="Filial"
                                                                                    variant="standard"/>}

                                                autoHighlight
                                                disableClearable
                                                onChange={(event, newValue) => {
                                                    this.setState(prevState => ({
                                                        form: {
                                                            ...prevState.form,
                                                            'filial': newValue.id
                                                        }
                                                    }))
                                                }}


                                            />


                                        </div>
                                    </div>
                                </div>
                            </AccordionItem>
                        </Accordion>
                    )}
                </form>
            </div>
        );
    }
}
